import { EDruhUplatneni } from 'enums/isin/udaje/druhUplatneni';

const warrantOpceSelect = [
    {
        value: EDruhUplatneni.E,
        labelcz: 'ISIN_EMISE_WARRANT_OPCE_E'
    },
    {
        value: EDruhUplatneni.A,
        labelcz: 'ISIN_EMISE_WARRANT_OPCE_A'
    },
    {
        value: EDruhUplatneni.B,
        labelcz: 'ISIN_EMISE_WARRANT_OPCE_B'
    },
    {
        value: EDruhUplatneni.O,
        labelcz: 'ISIN_EMISE_WARRANT_OPCE_O'
    }
];

export default warrantOpceSelect;
